import { render, staticRenderFns } from "./paymentWage.vue?vue&type=template&id=ffe4ec90&scoped=true&"
import script from "./paymentWage.vue?vue&type=script&lang=js&"
export * from "./paymentWage.vue?vue&type=script&lang=js&"
import style0 from "./paymentWage.vue?vue&type=style&index=0&id=ffe4ec90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe4ec90",
  null
  
)

export default component.exports